/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ParkingPlace } from '../../models/parking-place';

export interface ApiParkingPlaceGetParkingPlaceWithParkingSpotsGet$Plain$Params {
  parkingPlaceId?: number;
}

export function apiParkingPlaceGetParkingPlaceWithParkingSpotsGet$Plain(http: HttpClient, rootUrl: string, params?: ApiParkingPlaceGetParkingPlaceWithParkingSpotsGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ParkingPlace>> {
  const rb = new RequestBuilder(rootUrl, apiParkingPlaceGetParkingPlaceWithParkingSpotsGet$Plain.PATH, 'get');
  if (params) {
    rb.query('parkingPlaceId', params.parkingPlaceId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ParkingPlace>;
    })
  );
}

apiParkingPlaceGetParkingPlaceWithParkingSpotsGet$Plain.PATH = '/api/ParkingPlace/GetParkingPlaceWithParkingSpots';
